<template>
  <div class="pe-form">
    <el-form :model="childConfigInfo" :rules="rules" v-loading="loading" ref="childConfigInfo" label-width="120px"
             class="demo-ruleForm">
      <el-form-item label="质控价格" prop="textarea" style="margin-bottom:0">
        <span>当前项目去重后总字数{{ childConfigInfo.remark }}字/词（中朝或非中文单词）</span><br>
      </el-form-item>
      <div v-show="childConfigInfoList.length>0" v-for="(item,index) in childConfigInfoList" :key="index">
        <el-form-item
          :label="item.taskType===1?'主质控任务':'质控子任务'+ index"
          prop="wordNum" style="margin-bottom:0;font-weight: bold">
          <div style="display: flex;    line-height: 10px;">
            <span style="width: 70px ; font-weight: 700;    line-height: 30px;">分配字数:</span>
            <el-input-number el-input-number :controls="false" :precision="0" :min="0"
                             placeholder="请输入分配字数" :disabled="true"
                             v-model.number="item.wordNum"/>
            <p style="padding-left: 5px;color: lightgray; font-size: 12px; font-weight: normal;">
              此字数为预计字数,实际确认字数会不小于分配字数,以确定后字数为准</p>
          </div>
        </el-form-item>
        <el-form-item label="" label-width="35px" prop="priceType"
                      style="margin-bottom:0;padding-top: 10px">
          <span style="padding: 0 20px 0 10px ;">质控价格</span>
          <el-radio-group v-model="item.priceType"
                          :disabled="item.qcPriceChangeFlag"
                          prop="priceType">
            <el-radio :label="1">一口价</el-radio>
            <el-radio :label="2">字数*千字单价</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="" prop="price">
          <el-input-number v-if="item.priceType===1" :controls="false" v-model="childConfigInfoList[index].amount" :precision="2" :min="0"
                           placeholder="请输入质控价格" :disabled="item.qcPriceChangeFlag"/>
          <el-input-number v-if="item.priceType===2" :controls="false" v-model="childConfigInfoList[index].price" :precision="2" :min="0"
                           placeholder="请输入质控价格" :disabled="item.qcPriceChangeFlag"/>
          <span class="input-company" v-if="item.priceType===2">元/千字</span>
          <span class="input-company" v-if="item.priceType===1">元</span>
          <el-link type="danger" icon="el-icon-edit"
                   v-if="item.canEdit" @click="changeQcPrice(index)">
            修改
          </el-link>
          <span v-if="item.amount && item.priceType===2"
                style="margin-left:20px">共￥{{
              (item.price * item.wordNum/1000).toFixed(2)
            }}</span>
          <p class="input-note"
             v-if="!childConfigInfo.isConfigDisabled">
            建议价格：{{ recommendPrice }}元/千字</p>
        </el-form-item>
        <el-form-item label="选择质控人">
          <span>质控一次可推送多人，一个人领取后其他人则无法看到此任务</span><br>
          <el-button type="primary" @click.stop="showZktr(index)"
                     :disabled="item.qcPriceChangeFlag">选择质控人
          </el-button>
          <ul class="ul-zkr">
            <li v-for="(it,ind) in item.userWebVos" :key="ind"><span>{{ it.realname }}</span>
            </li>
            <li v-for="(it,ind) in item.newQcList" :key="ind"><span>{{ it.realname }}</span>
              <i class="el-icon-close"
                 @click.stop="delZkr(it,ind)"/>
            </li>
          </ul>
          <el-button type="primary" :disabled="!item.priceType||item.qcPriceChangeFlag||item.newQcList.length===0" @click="allocationConfirm(childConfigInfo.status === 1)">
            分配确定
          </el-button>
        </el-form-item>
      </div>
      <el-form-item label="任务截止时间" prop="limitTime">
        <el-date-picker
          v-model="childConfigInfo.limitTime"
          :disabled="childConfigInfo.isConfigDisabled || childConfigInfo.status === 2"
          type="datetime"
          @input="handleTiem"
          format='yyyy-MM-dd HH:mm'
          valueFormat='timestamp'
          :pickerOptions="this.pickerOptions"
          placeholder="选择任务截止时间">
        </el-date-picker>
        <p class="input-note">截止时间不能小于PE结束时间</p>
      </el-form-item>
      <el-form-item v-if="configInfo.status === 1">
        <el-button size="medium" type="primary" v-if="childConfigInfo.isQcCanChoose  && permissions.dot_flow_start"
                   @click.stop="submitForm('childConfigInfo')" style="min-width:160px">确定
        </el-button>
        <el-button size="medium" type="primary" v-if="childConfigInfo.isQcCanChoose  && permissions.dot_flow_start"
                   @click="resetForm('childConfigInfo')" style="min-width:160px">重置</el-button>
      </el-form-item>
    </el-form>

    <el-dialog title="选择邀请人" :visible.sync="dialogZktr" :before-close="handleClose">
      <avue-crud :option="qcOption" :data="childQcData" :search.sync="search" @search-change="searchChange" ref="crud">
        <template slot="search">
          <span style="padding-top: 5px">资源类型：</span>
          <el-select style="width: auto!important" v-model="search.resource" clearable placeholder="请选择">
            <el-option
              v-for="item in search.options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="el-form-item el-form-item--small" style="line-height: 32px;margin-left: 20px;">
            <el-checkbox v-model="search.isProceed">未被占用（无进行中任务）</el-checkbox>
          </div>
        </template>
        <template slot="isProceed" slot-scope="scope">
          <span v-if="scope.row.isProceed===1">是</span>
          <span v-if="scope.row.isProceed===0">否</span>
        </template>
        <template slot-scope="{row}" slot="menu">
          <el-button type="primary" size="mini" @click.stop="addTr(row,currentIndex)">添加</el-button>
        </template>
      </avue-crud>
    </el-dialog>

  </div>

</template>

<script>

import {
  listQC,
  qcStart,
  addQc,
  qcStarts,
  updateQcTask,
  configQcTaskByQc,
  configQcTaskByPm,
  checkWordNumByPm,
  checkWordNumByQc, qcConfigInfo
} from '@/api/dot/qc';
import {recommend} from '@/api/dot/order'
import {mapGetters} from "vuex";
import {alertErroMsg, alertSuccessMsg, alertCommon} from "@/util/commonMsg";


export default {
  props: ['configInfo'],
  data() {
    var checkAllocateWordsCount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('分配字数不能为空'));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入分配字数'));
        } else {
          // console.log(value,this.childConfigInfo.wordNum,this.compWords)
          // let newVar = this.childConfigInfo.wordNum + this.compWords;
          if ( value < 1000 ) {
            // callback(new Error('分配字数不得少于1000'));
            callback();
          } else {
            callback();
          }
        }
      }, 50);
    };
    var checkPrice =(rule,value,callback) =>{
      let res;
      if (this.childConfigInfoList[this.currentIndex].priceType === 1) {
        res = this.childConfigInfoList[this.currentIndex].amount;
      }else {
        res = this.childConfigInfoList[this.currentIndex].price
      }
      if (!res) {
        return callback(new Error('请输入价格'));
      }
    }
    // 判断是pm还是qc
    var pmOrQc = () => {
      let path = this.$route.path;
      if (path.indexOf('detail-qc') > 0) {
        return true;
      } else if (path.indexOf('multi-qc') > 0) {
        return false;
      }
    };
    return {
      currentIndex:0,
      sort:null,// 上一个任务的最后包序号
      hasLoad: false,
      loading: false,
      childConfigInfo: this.configInfo,
      recommendPrice: {},
      childConfigInfoList: [],
      pmOrQc:pmOrQc(),
      rules: {
        price: [
          // {required: true, message: '请输入价格', trigger: 'blur'}
          {validator: checkPrice,  trigger: 'blur'}
        ],
        limitTime: [
          {required: true, message: '请选择截止时间', trigger: 'blur'}
        ],
        wordNum: [
          {validator: checkAllocateWordsCount, trigger: 'blur'}
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      qcData: [],
      qcOption: {
        filterBtn: true,
        card: true,
        emptyBtn: false,
        refreshBtn: false,
        header: false, //表格头部中间菜单
        page: false,
        menu: true,
        addBtn: false, //新增按钮
        columnBtn: false,
        delBtn: false,
        editBtn: false,
        searchSpan: 10,
        searchMenuSpan: 4,
        menuWidth: 100,
        column: [
          {
            label: "质控人",
            prop: 'realname',
            search: true,
          },
          {
            label: "是否有进行中轻任务",
            prop: "isProceed",
          }, {
            label: "资源类型",
            prop: "userType",
          }
        ]
      },
      childQcData: [],
      search: {
        resource:'',
        options: [{
          value: '兼职',
          label: '兼职'
        }, {
          value: '全职',
          label: '全职'
        }, {
          value: '团队',
          label: '团队'
        }, {
          value: '公司',
          label: '公司'
        }],
      },
      newQcList: [],
      dialogZktr: false,
    };
  },
  watch: {
    'configInfo': function (n, o) {
      this.childConfigInfo = n;
    },
    'configInfo.wordsCount': function (n, o) {
      this.childConfigInfo.wordNum = n;
    },
    // childConfigInfoList: {
    //   handler(n, o) {
    //     this.childConfigInfo.wordNum = this.childConfigInfo.wordsCount - this.compWords;
    //   },
    //   deep: true
    // }
  },
  mounted() {
    // 待领取状态下才需要发送请求
    qcConfigInfo({orderId:this.configInfo.orderId,qcOrPm:''}).then(resp=>{
      this.childConfigInfoList = resp.data.data;
      this.childConfigInfoList.map(it => {
        it.qcPriceChangeFlag = true;
        it.newQcList = it.userWebVos;
        it.userWebVos = [];
      });
    });
  },
  updated() {

    if (this.childConfigInfo.status === 1 && !this.hasLoad) {
      this.hasLoad = true
      recommend(this.childConfigInfo.orderId, 3).then(res => {
        this.recommendPrice = res.data.data
      })
    }
  },
  computed: {
    ...mapGetters(['permissions','userInfo']),
    allocation() {
      return !this.childConfigInfoList[this.currentIndex].wordNum
        || !this.childConfigInfoList[this.currentIndex].priceType
        || !this.childConfigInfoList[this.currentIndex].qcPriceChangeFlag
        || this.childConfigInfoList[this.currentIndex].userWebVos.length === 0 ;
    },
    // compWords() {
    //   return this.childConfigInfoList.length > 0 ? this.childConfigInfoList.map(
    //     it => it.wordNum).reduce((a, b) => a + b, 0) : 0;
    // }
  },
  methods: {

    // 分配确认
    allocationConfirm(flag) {
      let wordNum = this.childConfigInfo.wordNum;
      if (flag) {
        let newVar = this.childConfigInfo.wordNum + this.compWords;
        if ((this.childConfigInfo.wordsCount - this.compWords >= 1000 || newVar
          < this.childConfigInfo.wordsCount) && this.childConfigInfo.wordNum < 1000) {
          this.$message.error("分配字数不得小于1000")
          return;
        }
        let price = this.$refs['childConfigInfo'].model.price
        if (this.$refs['childConfigInfo'].model.priceType === 2) {
          price = (this.$refs['childConfigInfo'].model.price / 1000 ) * (this.childConfigInfo.wordsCount < 1
            ? 1 : this.childConfigInfo.wordsCount)
        }
        if (price < 3) {
          this.$alert('您填写的价格远低于平台平均价格，确定提交？', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showCancelButton: true,
            callback: action => {
              if (action === 'confirm') {
                this.$refs['childConfigInfo'].model.newQcList = this.newQcList;
                let limitTime = this.$refs['childConfigInfo'].model.limitTime
                this.childConfigInfoList.push(
                  JSON.parse(JSON.stringify(this.$refs['childConfigInfo'].model)));
                this.$refs['childConfigInfo'].resetFields();
                this.$refs['childConfigInfo'].model.limitTime = limitTime;
                this.newQcList = []
              }
            },
          });
        } else {
          this.$refs['childConfigInfo'].model.newQcList = this.newQcList;
          let limitTime = this.$refs['childConfigInfo'].model.limitTime
          this.childConfigInfoList.push(
            JSON.parse(JSON.stringify(this.$refs['childConfigInfo'].model)));
          this.$refs['childConfigInfo'].resetFields();
          this.$refs['childConfigInfo'].model.limitTime = limitTime;
          this.newQcList = []
        }
        if (this.pmOrQc) {
          this.checkWordNumByPm({
            orderId: this.childConfigInfo.orderId,
            sort: this.sort,
            word: wordNum
          })
        } else {
          this.checkWordNumByQc({
            orderId: this.childConfigInfo.orderId,
            sort: this.sort,
            word: wordNum
          })
        }
      } else {
        // console.log(this.childConfigInfoList[this.currentIndex],this.childConfigInfoList[this.currentIndex].amount)
        let price = this.childConfigInfoList[this.currentIndex].amount
        // console.log(price)
        if (this.childConfigInfoList[this.currentIndex].priceType === 2) {
          price = (this.childConfigInfoList[this.currentIndex].price / (this.childConfigInfo.wordsCount < 1
            ? 1 : this.childConfigInfo.wordsCount)) * 1000
        }
        if (price < 3) {
          this.$alert('您填写的价格远低于平台平均价格，确定提交？', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showCancelButton: true,
            callback: action => {
              if (action === 'confirm') {
                updateQcTask({
                  qcTaskId: this.childConfigInfoList[this.currentIndex].id,
                  priceType: this.childConfigInfoList[this.currentIndex].priceType,
                  price: this.childConfigInfoList[this.currentIndex].priceType === 1 ? null
                    : this.childConfigInfoList[this.currentIndex].price,
                  amount: this.childConfigInfoList[this.currentIndex].priceType === 1
                    ? this.childConfigInfoList[this.currentIndex].amount
                    : (this.childConfigInfoList[this.currentIndex].price
                      * this.childConfigInfoList[this.currentIndex].wordNum / 1000).toFixed(2),
                  qcIds: this.childConfigInfoList[this.currentIndex].newQcList.map(it => it.staffId)
                }).then(response => {
                  if (response.data.data >= 0) {
                    alertSuccessMsg("保存成功")
                  } else if (response.data.data === -2) {
                    alertErroMsg("任务状态已变更，请刷新后重试")
                  } else if (response.data.data() === -3) {
                    alertErroMsg("金额超过主任务金额");
                  } else {
                    alertErroMsg("保存失败");
                  }
                })
              }
            },
          });
        } else {
          updateQcTask({
            qcTaskId: this.childConfigInfoList[this.currentIndex].id,
            priceType: this.childConfigInfoList[this.currentIndex].priceType,
            price: this.childConfigInfoList[this.currentIndex].priceType === 1 ? null
              : this.childConfigInfoList[this.currentIndex].price,
            amount: this.childConfigInfoList[this.currentIndex].priceType === 1 ? this.childConfigInfoList[this.currentIndex].amount
              : (this.childConfigInfoList[this.currentIndex].price
                * this.childConfigInfoList[this.currentIndex].wordNum/1000).toFixed(2),
            qcIds:this.childConfigInfoList[this.currentIndex].newQcList.map(it=>it.staffId)
          }).then(response => {
            if (response.data.data >= 0) {
              alertSuccessMsg("保存成功")
            } else if (response.data.data === -2) {
              alertErroMsg("任务状态已变更，请刷新后重试")
            } else if (response.data.data() === -3) {
              alertErroMsg("金额超过主任务金额");
            } else {
              alertErroMsg("保存失败");
            }
          })
        }
      }
    },

    // checkWordNumByPm
    checkWordNumByPm(obj) {
      checkWordNumByPm(obj).then(res=>{
        let result = res.data.data;
        // console.log(result)
        this.childConfigInfoList[this.childConfigInfoList.length-1].wordNum =result.wordCount;
        this.childConfigInfoList[this.childConfigInfoList.length-1].startSort =result.startSort;
        this.childConfigInfoList[this.childConfigInfoList.length-1].endSort =result.endSort;
        this.childConfigInfoList[this.childConfigInfoList.length - 1].taskType = (result.startSort === 1 ? 1 : 2);// 类型：1主任务 2子任务
        this.sort = result.endSort;
      });
    },
    // checkWordNumByQc
    checkWordNumByQc(obj) {
      checkWordNumByQc(obj).then(res=>{
        let result = res.data.data;
        // console.log(result)
        this.childConfigInfoList[this.childConfigInfoList.length-1].wordNum =result.wordCount;
        this.childConfigInfoList[this.childConfigInfoList.length-1].startSort =result.startSort;
        this.childConfigInfoList[this.childConfigInfoList.length-1].endSort =result.endSort;
        this.childConfigInfoList[this.childConfigInfoList.length - 1].taskType = (result.startSort === 1 ? 1 : 2);// 类型：1主任务 2子任务
        this.sort = result.endSort;
      });
    },
    // 修改QC价格
    changeQcPrice(index) {
      this.currentIndex = index;
      this.childConfigInfoList[this.currentIndex].qcPriceChangeFlag = !this.childConfigInfoList[this.currentIndex].qcPriceChangeFlag;
      this.childConfigInfoList[index].canEdit = !this.childConfigInfoList[index].canEdit;
      this.$forceUpdate();
      // this.childConfigInfo.isConfigDisabled = this.qcPriceChangeFlag;
      // this.newQcList = this.childConfigInfo.qcList
      // console.log(this.childConfigInfo.qcList, this.newQcList);
    },
    handleTiem(val) {
      this.$forceUpdate()    //需要使用强制更新
      this.childConfigInfo.limitTime = val //赋值
    },
    startQc(formName) {
      // if (!this.$refs[formName].model.priceType) {
      //   this.$message.error("请选择价格类型")
      //   this.loading = false
      //   return;
      // }

      if (this.childConfigInfo.status === 1 && this.$refs[formName].model.limitTime < Date.now()) {
        this.$message.error("不可选择过去时间")
        this.loading = false
        return;
      }
      let peEndTime = this.childConfigInfo.peEndTime ? parseInt(this.childConfigInfo.peEndTime) : 0;
      if ((this.childConfigInfo.status === 1 || this.childConfigInfo.status === 2) && this.$refs[formName].model.limitTime < peEndTime) {
        this.$message.error("不可选择小于PE结束时间")
        this.loading = false
        return;
      }

      // if (this.newQcList.length === 0 && this.childConfigInfo.status === 1) {
      //
      //   // if (this.childConfigInfo.status === 1) {
      //     this.$message.error("请选择质控人")
      //   // }
      //   // else if (this.childConfigInfo.status === 2) {
      //   //   this.$message.error("没有变更项，无需保存")
      //   // }
      //   this.loading = false
      //
      //   return;
      // }
      let tempAmount = 0;
      this.childConfigInfoList.forEach(it=>{
        if (it.priceType === 2) {
         it.amount = it.price * it.wordNum/1000
        }else {
          it.amount = it.price
        }
      })
      console.log(this.childConfigInfoList)
      tempAmount = this.childConfigInfoList.reduce((fr,lt)=>{return lt.amount + fr},0)
      // console.log(tempAmount)
      if (tempAmount > this.childConfigInfo.amount) {
        this.$message.error("你分配的质控金额大于该项目质控总金额")
        this.loading = false
        return;
      }
      let qcIds = [];
      this.newQcList.forEach(ele => {
        qcIds.push(ele.staffId);
      })
      let oldQcIds = []
      this.childConfigInfo.qcList.forEach(it=>{
        oldQcIds.push(it.staffId)
      })
      this.childConfigInfoList.forEach(it=>{
        it.qcIds = it.newQcList.map(item => item.staffId);
      })
      // console.log(this.childConfigInfoList)
      // 待配置
      if (this.childConfigInfo.status === 1) {

        // qcStart(Object.assign(this.$refs[formName].model, {
        //   flowId: this.$route.params.id,
        //   qcIds: qcIds.join(",")
        // })).then(response => {
        //   alertCommon(response.data.data)
        // })
        let flowInfo = {
          dot: this.childConfigInfoList,
          limitTime: this.$refs[formName].model.limitTime,
          orderId:this.childConfigInfo.orderId,
        };
        console.log(this.childConfigInfoList);
        if (this.pmOrQc) {
          configQcTaskByPm(flowInfo).then(response => {
            alertCommon(response.data.data)
          })
        } else {
          configQcTaskByQc(flowInfo).then(response => {
            alertCommon(response.data.data)
          })
        }

      // 待领取
      } else if (this.childConfigInfo.status === 2) {
        // addQc(Object.assign(this.$refs[formName].model,{
        //   flowId: this.$route.params.id,
        //   qcIds: qcIds.concat(oldQcIds).join(",")
        // })).then(response => {
        //
        //   if (response.data.data > 0) {
        //     alertSuccessMsg("保存成功")
        //   } else if (response.data.data === -1) {
        //     alertErroMsg("保存失败，质控任务已被领取")
        //   } else {
        //     alertErroMsg("保存失败")
        //   }
        // })
        updateQcTask({
          qcConfigDtoList: this.childConfigInfoList,
          limitTime: this.$refs[formName].model.limitTime,
          orderId:this.childConfigInfo.orderId,
        }).then(response => {

          if (response.data.data > 0) {
            alertSuccessMsg("保存成功")
          } else if (response.data.data === -1) {
            alertErroMsg("保存失败，质控任务已被领取")
          } else {
            alertErroMsg("保存失败")
          }


        })
      }

    },
    submitForm(formName) {
      this.startQc(formName);
    },
    resetForm(formName) {
      this.$alert(`你即将重置该质控任务配置`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        callback: action => {
          if (action === 'confirm') {
            let limitTime = this.$refs['childConfigInfo'].model.limitTime
            this.$refs[formName].resetFields();
            this.$refs[formName].model.limitTime = limitTime;
            this.childConfigInfoList = [];
            this.newQcList = [];
            this.sort = null;
          } else {
            // this.childConfigInfoList = [];
          }
        },
      });
    },
    //弹窗
    showZktr(index) {
      if (this.qcData.length === 0) {
        listQC().then(res => {
          this.qcData = res.data.data
          this.childQcData = this.qcData
          this.dialogZktr = true
        });
      }
      this.dialogZktr = true
      this.currentIndex = index;
      console.log(this.currentIndex);
    },
    handleClose() {
      this.dialogZktr = false
    },
    searchChange(params, done) {
      done();
      this.childQcData = this.qcData
      let temp = []

      if (!params) {
        this.childQcData = this.qcData
      } else {
        this.childQcData.forEach(ele => {
          if (params.realname && params.realname !== ele.realname) return
          if (params.isProceed && ele.isProceed === 1) return
          if (params.resource && params.resource !== ele.userType) return;
          temp.push(ele)
        })
      }

      this.childQcData = temp
    },
    addTr(row, index) {

      if (this.childConfigInfoList[index].newQcList == null) this.childConfigInfoList[index].newQcList = []
      if (this.childConfigInfo.userWebVos == null) this.childConfigInfo.userWebVos = []
      let temp = []
      temp = temp.concat(this.childConfigInfoList[index].newQcList).concat(this.childConfigInfo.userWebVos);
      if (!temp.find(item => item.staffId === row.staffId)) {
        this.childConfigInfoList[index].newQcList.push(row)
        this.$message.success(row.realname + "，添加成功")
      } else {
        this.$message.error(row.realname + "，已添加该质控人")
      }
    },
    delZkr(item, index) {
      // this.$message.success(index)
      if (this.childConfigInfoList[this.currentIndex].qcPriceChangeFlag) {
        this.$message.info("请点击修改后操作!")
        return;
      }
      this.childConfigInfoList[this.currentIndex].newQcList.splice(index, 1);
      this.$forceUpdate();
    }
  },
  filters: {},
}

</script>
<style lang="scss" scoped>
.input-note {
  margin: 0;
}

ul.ul-zkr {
  padding: 0;

  > li {
    width: auto;
    height: 30px;
    display: inline-block;
    list-style: none;
    line-height: 30px;
    background: #b3d8ff;
    color: #FFFFFF;
    text-align: center;
    margin-right: 10px;
    border-radius: 3px;

    > span {
      padding: 0 10px;
    }

    > .el-icon-close {
      margin-right: 3px;
      cursor: pointer;
    }
  }
}

.el-dialog__wrapper {
  :deep(.avue-group--card:last-child) {
    margin-bottom: 0 !important;
  }
}
.el-row {
  min-height: 36px;
  &:last-child {
    margin-bottom: 0;
  }
}
.common-content{
  font-size: 14px;
}
.grid-content {
  font-size: 14px;
  font-weight: bold;
  font-family: "Microsoft YaHei",sans-serif;
}
.bg-purple{
  font-size: 12px;
  color: lightgray;
}
</style>

